<template>
    <div class="top_nav">
      <ul style="float:right;
                list-style-type: none;
                padding: 0px;
                margin: 0px;
                height:35px;
                font-size:13px;
                line-height:35px;
                margin-right: 15px">
        <li style="color:#3a8ee6">
           欢迎：{{this.$store.state.userInfo.user.userName}}
        </li>
      </ul>

      <i class="el-icon-location-outline" style="float:left;margin:0 5px;position:relative;top:8px"></i>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="height:35px; line-height: 35px">
        <el-breadcrumb-item :key="item.path" v-for="(item,index) in levelList">
          <router-link :to="item.path">{{item.name}}</router-link>
        </el-breadcrumb-item>
      </el-breadcrumb>


    </div>
</template>

<script>
    export default {
        name: "content_nav",
        data(){
          return {
            levelList:null,
            date:"",
            time:"",
            week:""
          }
        },
        created() {
          this.getBreadcrumb()
        },
        watch:{
          $route(){
            this.getBreadcrumb()
          }
        },
        methods:{
          getBreadcrumb(){
            let matched=this.$route.matched.filter(item=>item.name)//$route.matched 将会是一个包含从上到下的所有对象 (副本)。
            this.levelList=matched
          },
          freshTime(){
            let deviationSenconds  = this.$store.state.deviationSenconds;
            let serverDateTime =new Date(new Date().getTime()+parseInt(deviationSenconds));
            this.date=serverDateTime.format("yyyy年MM月dd日");
            this.time=serverDateTime.format("hh时mm分ss秒");
            let weekArray = new Array("日", "一", "二", "三", "四", "五", "六");
            this.week="星期"+weekArray[serverDateTime.getDay()];
          }
        },
        mounted(){
          // this.freshTime();
          // window.setInterval(this.freshTime,1000);
        }
    }
</script>

<style scoped>
  .top_nav{
    height:35px;
    line-height: 35px;
    font-size:20px;
  }
  ul li{
    float:left
  }
</style>



// WEBPACK FOOTER //
// src/components/content_nav.vue